import Equipment from "./../equipment";
import { recipeTypes } from "../recipeTypes";

const ingredient = (quantity: string | number, name: string, details = "") => ({ quantity, unit: "", name, details });

export const Fried_chicken = {
  type: recipeTypes.main,
  title: "Fried chicken",
  subtitle: "crispy, brined",
  background: require("../../media/fried_chicken.jpg"),
  details: ["Crispy outside, juicy inside.", "Makes 6 portions."],
  equipment: [Equipment.Mixing_bowl("large"), Equipment.Frying_pan("deep"), Equipment.Tongues(), Equipment.Baking_rack()],
  optional_equipment: [],
  ingredients: [
    ingredient("1.4kg", "chicken thighs or drumsticks"),
    ingredient("4 cups", "milk", "or water"),
    ingredient("1/4 cup", "salt"),
    ingredient("2 cups", "flour"),
    ingredient("2 cups", "cornflour"),
    ingredient("1 Tablespoon", "garlic powder"),
    ingredient("1 Tablespoon", "paprika"),
    ingredient("1 teaspoon", "baking powder"),
    ingredient("", "oil", "for frying"),
  ],
  optional_ingredients: [ingredient("1 teaspoon", "cayenne pepper")],
  prep: ["Brine CHICKEN 2h or overnight", "Mix dry coating", "Make a thin wet batter from some coating and water"],
  prep_time: 180,
  method: ["Dip CHICKEN in batter", "Press into dry coating", "Rest while oil heats", "Fry at 175°C until golden and cooked", "Drain on rack"],
  cook_time: 15,
};

export const Red_lentil_dahl = {
  type: recipeTypes.main,
  title: "Red lentil dahl",
  subtitle: "with coconut milk",
  background: require("../../media/red_lentil_dahl.jpg"),
  details: ["Fast, creamy and vegan.", "Good with rice or naan."],
  equipment: [Equipment.Pot("large"), Equipment.Spoon()],
  optional_equipment: [],
  ingredients: [
    ingredient("1 Tablespoon", "olive oil"),
    ingredient(1, "onion", "chopped"),
    ingredient(5, "garlic cloves", "minced"),
    ingredient("1 Tablespoon", "ginger", "grated"),
    ingredient("1 Tablespoon", "garam masala"),
    ingredient("1 teaspoon", "turmeric"),
    ingredient("1 1/2 cups", "red lentils"),
    ingredient("400g", "diced tomatoes"),
    ingredient("400ml", "coconut milk"),
    ingredient("3 cups", "vegetable broth"),
  ],
  optional_ingredients: [ingredient("", "spinach"), ingredient("", "lemon juice")],
  prep: ["Chop onion", "Mince garlic and ginger", "Rinse lentils"],
  prep_time: 10,
  method: ["Fry ONION", "Add GARLIC, GINGER and spices", "Add LENTILS, TOMATOES, COCONUT MILK and BROTH", "Simmer 15-20 min", "Season"],
  cook_time: 20,
};

export const Pilau_rice = {
  type: recipeTypes.side,
  title: "Pilau rice",
  subtitle: "spiced basmati",
  background: require("../../media/pilau_rice.jpg"),
  details: ["Fragrant rice side.", "Makes 6 portions."],
  equipment: [Equipment.Pot("with lid"), Equipment.Sieve(), Equipment.Spoon()],
  optional_equipment: [],
  ingredients: [
    ingredient("300g", "basmati rice"),
    ingredient("30g", "butter", "or 2 Tablespoons oil"),
    ingredient(1, "onion", "chopped"),
    ingredient(1, "cinnamon stick"),
    ingredient("1 teaspoon", "cumin seeds"),
    ingredient(6, "cardamom pods"),
    ingredient(4, "cloves"),
    ingredient(2, "bay leaves"),
    ingredient("1/2 teaspoon", "turmeric"),
    ingredient("500ml", "vegetable stock"),
  ],
  optional_ingredients: [],
  prep: ["Rinse RICE until mostly clear", "Drain well", "Chop ONION"],
  prep_time: 10,
  method: ["Fry ONION in BUTTER", "Add spices", "Stir in RICE", "Add STOCK", "Cover and cook low 2 min", "Turn off and rest 15 min", "Fluff"],
  cook_time: 30,
};

export const Naan = {
  type: recipeTypes.bread,
  title: "Naan",
  subtitle: "pan bread",
  background: require("../../media/naan.jpg"),
  details: ["Soft, bubbly flatbread.", "Makes 6."],
  equipment: [Equipment.Mixing_bowl("large"), Equipment.Rolling_pin(), Equipment.Frying_pan("very hot"), Equipment.Cling_film()],
  optional_equipment: [],
  ingredients: [
    ingredient("1 teaspoon", "instant yeast"),
    ingredient("1/2 cup", "warm water"),
    ingredient("1 Tablespoon", "sugar"),
    ingredient("2 Tablespoons", "milk"),
    ingredient("1/2", "egg", "whisked"),
    ingredient("1 3/4 cups", "bread flour"),
    ingredient("30g", "butter", "melted"),
  ],
  optional_ingredients: [ingredient("", "garlic butter"), ingredient("", "coriander")],
  prep: ["Bloom YEAST with WATER and SUGAR", "Mix wet ingredients", "Mix into FLOUR", "Proof 1h", "Shape 6 balls", "Rest 15 min"],
  prep_time: 95,
  method: ["Roll thin", "Cook in very hot dry pan", "Flip when bubbly", "Brush with BUTTER"],
  cook_time: 10,
};

export const Focaccia = {
  type: recipeTypes.bread,
  title: "Focaccia",
  subtitle: "with rosemary",
  background: require("../../media/focaccia.jpg"),
  details: ["Olive oil bread.", "Makes 12 squares."],
  equipment: [Equipment.Mixing_bowl("large"), Equipment.Baking_tray("25 x 35cm"), Equipment.Oven_gloves()],
  optional_equipment: [],
  ingredients: [
    ingredient("500g", "bread flour"),
    ingredient("7g", "fast yeast"),
    ingredient("2 teaspoons", "salt"),
    ingredient("5 Tablespoons", "olive oil"),
    ingredient("350-400ml", "water", "lukewarm"),
    ingredient("", "rosemary"),
  ],
  optional_ingredients: [ingredient("", "flaky salt")],
  prep: ["Mix FLOUR, YEAST and SALT", "Add OIL and WATER", "Knead 5-10 min", "Proof 1h", "Stretch into oiled tray", "Proof 35-45 min"],
  prep_time: 105,
  method: ["Preheat oven to 220°C / 200°C FAN", "Dimple dough", "Add OIL, SALT and ROSEMARY", "Bake 20 min", "Drizzle with OIL"],
  cook_time: 20,
};

export const Seeded_bread = {
  type: recipeTypes.bread,
  title: "Seeded bread",
  subtitle: "no knead",
  background: require("../../media/seeded_bread.jpg"),
  details: ["Simple loaf with seeds.", "Good toasted."],
  equipment: [Equipment.Mixing_bowl("large"), Equipment.Loaf_tin(), Equipment.Baking_rack()],
  optional_equipment: [],
  ingredients: [
    ingredient("500g", "bread flour"),
    ingredient("7g", "yeast"),
    ingredient("2 teaspoons", "salt"),
    ingredient("350ml", "water"),
    ingredient("2 Tablespoons", "honey"),
    ingredient("100g", "mixed seeds"),
  ],
  optional_ingredients: [],
  prep: ["Mix everything", "Cover and rise until doubled", "Put in loaf tin"],
  prep_time: 90,
  method: ["Bake at 200°C / 180°C FAN for 35-40 min", "Cool on rack"],
  cook_time: 40,
};

export const Hungarian_mushroom_soup = {
  type: recipeTypes.main,
  title: "Hungarian mushroom soup",
  subtitle: "with paprika",
  background: require("../../media/Parsnip_soup.jpg"),
  details: ["Creamy mushroom soup.", "Paprika and dill."],
  equipment: [Equipment.Pot("large"), Equipment.Spoon()],
  optional_equipment: [],
  ingredients: [
    ingredient("450g", "mushrooms", "sliced"),
    ingredient(1, "onion", "chopped"),
    ingredient("2 Tablespoons", "butter"),
    ingredient("2 teaspoons", "paprika"),
    ingredient("2 teaspoons", "dill"),
    ingredient("500ml", "vegetable broth"),
    ingredient("250ml", "milk"),
    ingredient("120ml", "sour cream"),
  ],
  optional_ingredients: [ingredient("", "lemon juice"), ingredient("", "parsley")],
  prep: ["Slice MUSHROOMS", "Chop ONION"],
  prep_time: 10,
  method: ["Fry ONION and MUSHROOMS in BUTTER", "Add PAPRIKA and DILL", "Add BROTH and simmer", "Add MILK", "Finish with SOUR CREAM"],
  cook_time: 35,
};

export const Air_fryer_chicken_thighs = {
  type: recipeTypes.main,
  title: "Chicken thighs",
  subtitle: "air fryer",
  background: require("../../media/air_fryer_chicken_thighs.jpg"),
  details: ["Crispy skin, quick cook.", "Makes 4 portions."],
  equipment: [Equipment.Plate(), Equipment.Tongues()],
  optional_equipment: [],
  ingredients: [ingredient(4, "chicken thighs", "bone-in"), ingredient("1 teaspoon", "paprika"), ingredient("1/2 teaspoon", "mixed herbs"), ingredient("1 teaspoon", "olive oil")],
  optional_ingredients: [ingredient("1/2 teaspoon", "garlic granules")],
  prep: ["Mix spices", "Oil CHICKEN", "Coat with spices"],
  prep_time: 2,
  method: ["Air fry skin down at 180°C for 10 min", "Turn and cook 10-15 min more"],
  cook_time: 25,
};

export const Air_fryer_chicken_fried_rice = {
  type: recipeTypes.main,
  title: "Chicken fried rice",
  subtitle: "air fryer",
  background: require("../../media/air_fryer_chicken_fried_rice.jpg"),
  details: ["Fast rice bowl.", "Use cooked cold rice."],
  equipment: [Equipment.Mixing_bowl(), Equipment.Spoon()],
  optional_equipment: [],
  ingredients: [ingredient("2 cups", "cooked rice"), ingredient("200g", "cooked chicken"), ingredient(2, "eggs"), ingredient("1 cup", "mixed vegetables"), ingredient("2 Tablespoons", "soy sauce"), ingredient("1 Tablespoon", "oil")],
  optional_ingredients: [ingredient("", "spring onions")],
  prep: ["Break up cold RICE", "Dice CHICKEN", "Beat EGGS"],
  prep_time: 10,
  method: ["Mix RICE, CHICKEN, VEGETABLES, SOY and OIL", "Air fry 8 min", "Stir in EGGS", "Air fry until hot and set"],
  cook_time: 15,
};

export const Boiled_baked_ribs = {
  type: recipeTypes.main,
  title: "Ribs",
  subtitle: "boiled then baked",
  background: require("../../media/leg_of_lamb.jpg"),
  details: ["Tender ribs with sticky sauce.", "Finish in the oven."],
  equipment: [Equipment.Pot("large"), Equipment.Baking_tray(), Equipment.Aluminium_foil(), Equipment.Brush()],
  optional_equipment: [],
  ingredients: [ingredient("1.5kg", "pork ribs"), ingredient(1, "onion"), ingredient(2, "garlic cloves"), ingredient("1 cup", "barbecue sauce")],
  optional_ingredients: [ingredient("", "bay leaf"), ingredient("", "peppercorns")],
  prep: ["Cut RIBS to fit pot"],
  prep_time: 10,
  method: ["Simmer RIBS with ONION and GARLIC until tender", "Move to tray", "Brush with BBQ SAUCE", "Bake until sticky"],
  cook_time: 120,
};

export const Hamburger_patty = {
  type: recipeTypes.main,
  title: "Hamburger patties",
  subtitle: "beef burgers",
  background: require("../../media/hamburger_patty.jpg"),
  details: ["Juicy burger patties.", "Makes 6."],
  equipment: [Equipment.Mixing_bowl("large"), Equipment.Frying_pan("or grill"), Equipment.Spatula()],
  optional_equipment: [],
  ingredients: [ingredient("900g", "minced beef"), ingredient("1/2 cup", "crackers", "crushed"), ingredient(1, "egg"), ingredient("2 Tablespoons", "Worcestershire sauce"), ingredient("2 Tablespoons", "milk"), ingredient("1 teaspoon", "garlic powder"), ingredient("1 teaspoon", "onion powder")],
  optional_ingredients: [],
  prep: ["Mix gently", "Shape 6 patties", "Press a dent in the middle"],
  prep_time: 15,
  method: ["Cook medium heat 3-4 min per side", "Rest briefly"],
  cook_time: 8,
};

export const Hamburger_buns = {
  type: recipeTypes.bread,
  title: "Hamburger buns",
  subtitle: "soft rolls",
  background: require("../../media/shortbread.jpg"),
  details: ["Soft burger buns.", "Makes 8."],
  equipment: [Equipment.Mixing_bowl("large"), Equipment.Baking_tray(), Equipment.Baking_paper(), Equipment.Baking_rack()],
  optional_equipment: [],
  ingredients: [ingredient("500g", "bread flour"), ingredient("7g", "yeast"), ingredient("240ml", "milk"), ingredient("50g", "butter"), ingredient(1, "egg"), ingredient("2 Tablespoons", "sugar")],
  optional_ingredients: [ingredient("", "sesame seeds")],
  prep: ["Make soft dough", "Knead until smooth", "Proof until doubled", "Shape buns", "Proof again"],
  prep_time: 120,
  method: ["Brush with egg", "Bake at 190°C / 170°C FAN until golden", "Cool on rack"],
  cook_time: 15,
};

export const Fresh_tomato_soup = {
  type: recipeTypes.main,
  title: "Tomato soup",
  subtitle: "roasted fresh tomatoes",
  background: require("../../media/fresh_tomato_soup.jpg"),
  details: ["Fresh tomato soup.", "Roasted for deeper flavour."],
  equipment: [Equipment.Baking_tray(), Equipment.Pot("large"), Equipment.Vertical_blender()],
  optional_equipment: [],
  ingredients: [ingredient("1.3kg", "tomatoes"), ingredient(4, "garlic cloves"), ingredient("1/2", "onion"), ingredient("1/2", "red pepper"), ingredient("2 Tablespoons", "olive oil"), ingredient("500ml", "chicken broth")],
  optional_ingredients: [ingredient("120ml", "cream"), ingredient("", "parmesan")],
  prep: ["Cut TOMATOES", "Dice ONION and PEPPER"],
  prep_time: 10,
  method: ["Roast vegetables at 230°C", "Add to hot BROTH", "Blend smooth", "Add CREAM if using"],
  cook_time: 30,
};

export const Pancakes = {
  type: recipeTypes.bread,
  title: "Pancakes",
  subtitle: "old fashioned",
  background: require("../../media/banana_bread.jpg"),
  details: ["Simple breakfast pancakes.", "Makes about 8."],
  equipment: [Equipment.Mixing_bowl(), Equipment.Whisk(), Equipment.Frying_pan(), Equipment.Spatula()],
  optional_equipment: [],
  ingredients: [ingredient("1 1/2 cups", "flour"), ingredient("3 1/2 teaspoons", "baking powder"), ingredient("1 Tablespoon", "sugar"), ingredient("1 1/4 cups", "milk"), ingredient(1, "egg"), ingredient("3 Tablespoons", "butter", "melted")],
  optional_ingredients: [],
  prep: ["Mix dry ingredients", "Whisk wet ingredients", "Combine gently"],
  prep_time: 5,
  method: ["Cook in buttered pan", "Flip when bubbles form", "Serve warm"],
  cook_time: 15,
};

export const Tabbouleh = {
  type: recipeTypes.side,
  title: "Tabbouleh",
  subtitle: "parsley salad",
  background: require("../../media/tabbouleh.jpg"),
  details: ["Fresh herb salad.", "Good with grilled food."],
  equipment: [Equipment.Mixing_bowl(), Equipment.Knife(), Equipment.Cutting_board()],
  optional_equipment: [],
  ingredients: [ingredient("1/2 cup", "bulgur"), ingredient("2 bunches", "parsley"), ingredient("1/2 bunch", "mint"), ingredient(2, "tomatoes"), ingredient(1, "cucumber"), ingredient("3 Tablespoons", "olive oil"), ingredient("2 Tablespoons", "lemon juice")],
  optional_ingredients: [],
  prep: ["Soak BULGUR", "Chop herbs and vegetables"],
  prep_time: 25,
  method: ["Mix everything", "Season", "Chill briefly"],
  cook_time: 0,
};

export const Roasted_carrot_soup = {
  type: recipeTypes.main,
  title: "Carrot soup",
  subtitle: "roasted",
  background: require("../../media/roasted_carrot_soup.jpg"),
  details: ["Sweet roasted carrot soup.", "Smooth and simple."],
  equipment: [Equipment.Baking_tray(), Equipment.Pot("large"), Equipment.Vertical_blender()],
  optional_equipment: [],
  ingredients: [ingredient("900g", "carrots"), ingredient(1, "onion"), ingredient(2, "garlic cloves"), ingredient("1 teaspoon", "coriander"), ingredient("1/2 teaspoon", "cumin"), ingredient("1l", "vegetable broth")],
  optional_ingredients: [ingredient("", "butter"), ingredient("", "lemon juice")],
  prep: ["Slice CARROTS", "Chop ONION"],
  prep_time: 15,
  method: ["Roast CARROTS", "Fry ONION and GARLIC", "Add spices and BROTH", "Add CARROTS", "Simmer", "Blend"],
  cook_time: 50,
};

export const Cauliflower_quiche = {
  type: recipeTypes.main,
  title: "Cauliflower quiche",
  subtitle: "with cheese",
  background: require("../../media/Roasted_cauliflower_soup.jpg"),
  details: ["Simple vegetable quiche.", "Good warm or cold."],
  equipment: [Equipment.Baking_dish(), Equipment.Mixing_bowl(), Equipment.Whisk(), Equipment.Oven_gloves()],
  optional_equipment: [],
  ingredients: [ingredient(1, "pie crust"), ingredient("1/2", "cauliflower"), ingredient(4, "eggs"), ingredient("1 cup", "milk"), ingredient("1 cup", "cheese")],
  optional_ingredients: [ingredient("", "onion"), ingredient("", "nutmeg")],
  prep: ["Cook CAULIFLOWER until just tender", "Whisk EGGS and MILK"],
  prep_time: 15,
  method: ["Fill crust with CAULIFLOWER and CHEESE", "Pour over egg mix", "Bake until set"],
  cook_time: 45,
};

export const Japanese_cheesecake = {
  type: recipeTypes.bread,
  title: "Japanese cheesecake",
  subtitle: "souffle style",
  background: require("../../media/japanese_cheesecake.jpg"),
  details: ["Light, soft cheesecake.", "Bake in a water bath."],
  equipment: [Equipment.Mixer("electric"), Equipment.Mixing_bowl("large"), Equipment.Baking_dish("for water bath"), Equipment.Cake_tin?.() || Equipment.Loaf_tin()],
  optional_equipment: [],
  ingredients: [ingredient("225g", "cream cheese"), ingredient("60g", "butter"), ingredient("100ml", "milk"), ingredient(6, "eggs"), ingredient("140g", "sugar"), ingredient("70g", "flour"), ingredient("20g", "cornflour")],
  optional_ingredients: [ingredient("", "lemon zest")],
  prep: ["Melt CHEESE, BUTTER and MILK", "Separate EGGS", "Whip whites with SUGAR", "Fold gently"],
  prep_time: 40,
  method: ["Bake in water bath low and slow", "Cool gradually"],
  cook_time: 75,
};

export const French_carrot_salad = {
  type: recipeTypes.side,
  title: "Carrot salad",
  subtitle: "French style",
  background: require("../../media/french_carrot_salad.jpg"),
  details: ["Bright grated carrot salad.", "Lemon mustard dressing."],
  equipment: [Equipment.Grate(), Equipment.Mixing_bowl(), Equipment.Whisk()],
  optional_equipment: [],
  ingredients: [ingredient("500g", "carrots"), ingredient("2 Tablespoons", "olive oil"), ingredient("1 Tablespoon", "lemon juice"), ingredient("1 teaspoon", "mustard"), ingredient("", "parsley")],
  optional_ingredients: [],
  prep: ["Grate CARROTS", "Chop PARSLEY"],
  prep_time: 15,
  method: ["Whisk dressing", "Mix with CARROTS", "Rest 10 min"],
  cook_time: 0,
};

export const Crispy_roasted_cauliflower = {
  type: recipeTypes.side,
  title: "Cauliflower",
  subtitle: "crispy roasted",
  background: require("../../media/crispy_roasted_cauliflower.jpg"),
  details: ["Crispy panko cauliflower.", "Good snack or side."],
  equipment: [Equipment.Mixing_bowl(), Equipment.Baking_tray(), Equipment.Baking_paper()],
  optional_equipment: [],
  ingredients: [ingredient(1, "cauliflower"), ingredient("3 Tablespoons", "olive oil"), ingredient("1/2 cup", "panko"), ingredient("1/4 cup", "parmesan"), ingredient("1 teaspoon", "paprika"), ingredient("1 teaspoon", "garlic powder")],
  optional_ingredients: [],
  prep: ["Cut CAULIFLOWER", "Dry well", "Mix coating"],
  prep_time: 10,
  method: ["Roast at 220°C in one layer", "Flip halfway", "Serve hot"],
  cook_time: 25,
};

export const Cacio_e_pepe_chicken = {
  type: recipeTypes.main,
  title: "Chicken thighs",
  subtitle: "cacio e pepe",
  background: require("../../media/cacio_e_pepe_chicken.jpg"),
  details: ["Peppery cream sauce.", "Serve with greens or pasta."],
  equipment: [Equipment.Frying_pan("large"), Equipment.Plate(), Equipment.Spatula()],
  optional_equipment: [],
  ingredients: [ingredient(6, "chicken thighs", "bone-in, skin-on"), ingredient(1, "shallot"), ingredient(3, "garlic cloves"), ingredient("60ml", "white wine"), ingredient("180ml", "cream"), ingredient("120ml", "chicken broth"), ingredient("1 Tablespoon", "black pepper"), ingredient("3 Tablespoons", "pecorino")],
  optional_ingredients: [ingredient("", "lemon zest"), ingredient("", "parsley")],
  prep: ["Season CHICKEN", "Chop SHALLOT and GARLIC"],
  prep_time: 10,
  method: ["Brown CHICKEN both sides", "Remove", "Fry SHALLOT and GARLIC", "Add WINE, CREAM, BROTH and PEPPER", "Return CHICKEN and simmer", "Finish with CHEESE"],
  cook_time: 50,
};

export const Bone_broth_oats = {
  type: recipeTypes.bread,
  title: "Bone broth oats",
  subtitle: "dog treats",
  background: require("../../media/bone_broth_oats.jpg"),
  details: ["Dog treat biscuits.", "Not for onions/garlic diets."],
  equipment: [Equipment.Mixing_bowl(), Equipment.Rolling_pin(), Equipment.Baking_tray()],
  optional_equipment: [],
  ingredients: [ingredient("2 cups", "whole wheat flour"), ingredient("3 Tablespoons", "oats"), ingredient(1, "egg"), ingredient("2/3 cup", "beef broth")],
  optional_ingredients: [],
  prep: ["Mix dry ingredients", "Add EGG and BROTH", "Roll to 5mm"],
  prep_time: 10,
  method: ["Cut shapes", "Bake at 180°C for 10 min", "Cool"],
  cook_time: 10,
};

export const Tzatziki = {
  type: recipeTypes.sauce,
  title: "Tzatziki",
  subtitle: "yoghurt cucumber sauce",
  background: require("../../media/tzatziki.jpg"),
  details: ["Cool garlic yoghurt sauce.", "Good with grilled meat or pita."],
  equipment: [Equipment.Grate(), Equipment.Mixing_bowl()],
  optional_equipment: [Equipment.Sieve()],
  ingredients: [ingredient("1/2", "cucumber"), ingredient("1 cup", "Greek yogurt"), ingredient(1, "garlic clove"), ingredient("1 Tablespoon", "lemon juice"), ingredient("1 Tablespoon", "olive oil"), ingredient("", "dill")],
  optional_ingredients: [],
  prep: ["Grate CUCUMBER", "Squeeze out water", "Mince GARLIC"],
  prep_time: 10,
  method: ["Mix everything", "Chill"],
  cook_time: 0,
};

export const Beet_salmon_salad = {
  type: recipeTypes.main,
  title: "Salmon beet salad",
  subtitle: "horseradish yoghurt",
  background: require("../../media/beet_salmon_salad.jpg"),
  details: ["Warm salmon salad.", "Creamy horseradish base."],
  equipment: [Equipment.Frying_pan(), Equipment.Mixing_bowl(), Equipment.Platter()],
  optional_equipment: [],
  ingredients: [ingredient("450g", "salmon fillet"), ingredient("1 cup", "Greek yogurt"), ingredient("3 Tablespoons", "horseradish"), ingredient(1, "lemon"), ingredient(1, "shallot"), ingredient("250g", "cooked beets"), ingredient("", "dill")],
  optional_ingredients: [ingredient("", "endive")],
  prep: ["Season SALMON", "Mix YOGURT and HORSERADISH", "Slice SHALLOT and BEETS"],
  prep_time: 15,
  method: ["Pan fry SALMON", "Dress SHALLOT with LEMON and OIL", "Spread yoghurt on platter", "Add salad, BEETS and broken SALMON"],
  cook_time: 10,
};

export const Fruit_nut_flapjacks = {
  type: recipeTypes.bread,
  title: "Flapjacks",
  subtitle: "fruit and nut",
  background: require("../../media/fruit_nut_flapjacks.jpg"),
  details: ["Oat bars with seeds and fruit.", "Cool fully before cutting."],
  equipment: [Equipment.Mixing_bowl(), Equipment.Baking_dish(), Equipment.Baking_paper()],
  optional_equipment: [],
  ingredients: [ingredient("200g", "oats"), ingredient("30g", "nuts"), ingredient("50g", "dried fruit"), ingredient("110g", "butter", "melted"), ingredient("125g", "honey"), ingredient("1 teaspoon", "cinnamon")],
  optional_ingredients: [ingredient("", "pumpkin seeds"), ingredient("", "sesame seeds")],
  prep: ["Mix dry ingredients", "Add BUTTER and HONEY", "Press firmly into lined tin"],
  prep_time: 20,
  method: ["Bake at 180°C / 160°C FAN for 20 min", "Cool completely", "Cut squares"],
  cook_time: 20,
};
